import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.scss']
})
export class ZoneComponent implements OnInit {
  zoneForm: FormGroup;
  ListOfExamSchedule: any;
  filteredListOfExamSchedule: any;
  zoneList: any;
  filteredzoneList: any;
  APIService: string;
  SessionNo: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }

  dialogRef: MatDialogRef<any>;

  submitButton = true;
  updateButton = false;
  deleteButton = false;
  isDivShow = false;
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.submitButton = true;
    this.updateButton = false;
    this.deleteButton = false;
    this.zoneForm = this.fb.group({
      ZnShId: new FormControl('', [Validators.required]),
      ZnCode: new FormControl('', [Validators.required]),
      ZnName: new FormControl('', [Validators.required]),
    });

    this.fetchExam();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  fetchExam() {
    let payload = {}
    payload["ShSnNo"] = this.SessionNo;
    payload["ShStatus"] = '';
    payload["LoginId"] = sessionStorage.getItem('userId');
    this.umsService.fetchExShedule(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfExamSchedule = res.data;
        this.filteredListOfExamSchedule = this.ListOfExamSchedule.slice();
      }
      else {

      }

    });
  }

  saveZones() {
    if (this.zoneForm.invalid) {
      this.zoneForm.get('ZnShId').markAsTouched();
      this.zoneForm.get('ZnCode').markAsTouched();
      this.zoneForm.get('ZnName').markAsTouched();
      return;
    }
    else {
      this.submitZones();
    }
  }

  submitZones() {
    this.spinner.show();
    let submitpayload = this.zoneForm.value;
    this.umsService.addZone(submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.fetchZone(this.zoneForm.value.ZnShId);
        // this.reset();
        // this.dialogRef.afterClosed().subscribe(result => {
        //   // this.ngOnInit();
        //   this.resetForm();
        // });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });

  }

resetForm() {
    // this.zoneForm.reset();
    this.zoneForm.controls['ZnCode'].setValue('');
    this.zoneForm.controls['ZnName'].setValue('');
  }

  fetchZone(item) {
    this.spinner.show()
    const payload = {};
    payload['ZnShId'] = item;
    this.umsService.fetchZone(payload).subscribe((res) => {
      if (res.status) {
        this.zoneList = res.data;
        this.filteredzoneList = this.zoneList.slice();
        this.spinner.hide();
        if (res.data.length == 0) {
          this.isDivShow = false;
        }
        else {
          this.isDivShow = true;
        }
      }
      else {
        this.isDivShow = false;
        this.zoneList = [];
        this.spinner.hide();
      }

    });

  }


  prepopulation(id) {
    this.submitButton = false;
    this.updateButton = true;
    this.deleteButton = false;
    const payload = {};
    this.zoneForm = this.fb.group({
      ZnShId: new FormControl(this.zoneForm.value.ZnShId, [Validators.required]),
      ZnCode: new FormControl(id.ZnCode, [Validators.required]),
      ZnName: new FormControl(id.ZnName, [Validators.required]),
    });
  }


  editdata(item) {
    this.prepopulation(item);
  }

  updateZone() {
    this.spinner.show();
    let updatePayload = this.zoneForm.value;
    // updatePayload['ZnShId'] =this.zoneForm.value.ZnShId;
    this.umsService.updateZone(updatePayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.fetchZone(this.zoneForm.value.ZnShId);
        this.resetForm();
        this.submitButton = true;
        this.deleteButton = false;
        this.updateButton = false;
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  deletedata(item) {
    this.prepopulationForDelete(item);
  }

  prepopulationForDelete(id) {
    this.submitButton = false;
    this.updateButton = false;
    this.deleteButton = true;
    const payload = {};
    this.zoneForm = this.fb.group({
      ZnShId: new FormControl(this.zoneForm.value.ZnShId, [Validators.required]),
      ZnCode: new FormControl(id.ZnCode, [Validators.required]),
      ZnName: new FormControl(id.ZnName, [Validators.required]),
    });
  }


  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.delete(this.zoneForm.value);
      } else {
        this.ngOnInit();
      }
    });
  }


  delete(id) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        ZnShId: this.zoneForm.value.ZnShId,
        ZnCode: id.ZnCode,
        ZnName: id.ZnName,

      },
    };
    this.httpClient.delete(this.APIService + '/masters/zone', options)
      .subscribe((s) => {
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.fetchZone(this.zoneForm.value.ZnShId);
        this.resetForm();
        this.submitButton = true;
        this.deleteButton = false;
        this.updateButton = false;
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }, (ERROR: HttpErrorResponse) => {
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }

}
